module.exports = __webpack_public_path__ + "img/icon-user.297b1b2b.svg";